import { render, staticRenderFns } from "./addoredit.vue?vue&type=template&id=18eff354&scoped=true&"
import script from "./addoredit.vue?vue&type=script&lang=js&"
export * from "./addoredit.vue?vue&type=script&lang=js&"
import style0 from "./addoredit.vue?vue&type=style&index=0&id=18eff354&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18eff354",
  null
  
)

export default component.exports